import React from 'react';
import './NavigationTabs.css';

const NavigationTabs = () => {
  const currentPath = window.location.pathname;
  const currentTab = currentPath.includes('resources')
    ? 'resources'
    : currentPath.includes('playlists')
    ? 'playlists'
    : 'services';

  const linkStyle = {
    textDecoration: 'none',
  };

  return (
    <div className="nav-tabs-container">
        <div className="nav-tabs">
            <a
                href="https://www.fire-up.net/well-being/services"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'services' ? 'active' : ''}`}
            >
                Services
            </a>
            <a
                href="https://www.fire-up.net/well-being/resources"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'resources' ? 'active' : ''}`}
            >
                Resources
            </a>
            <a
                href="https://www.fire-up.net/well-being/playlists"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'playlists' ? 'active' : ''}`}
            >
                Playlists
            </a>
        </div>
        <button
            className="submit-button"
            onClick={() => window.open('https://1u2eip3ka2k.typeform.com/to/nWkrF76X', '_blank')}
        >
            Submit a service / resource / playlist
        </button>
    </div>
  );
};

export default NavigationTabs;
